import styled from "styled-components";

export const Container = styled.div`
    .row {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .col1 {
        width: 60%;
        padding: 10px;
    }

    .col2 {
        width: 40%;
        padding: 10px;
    }

    .Indicators {
        margin-bottom: 10%;
    }

    P {
        margin-top: 10%;
    }

    span {
        margin-left: 10%;
    }
`;

export const Title = styled.h4`
	font-weight: 500;
	font-size: 31px;
	line-height: 36px;
	color: var(--text-primary);
	margin: 20px 10px;
`;
